import axios from 'axios';

const BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost/neruda-tours';

// Log once on startup so we can confirm the URL is correct
console.log('[Neruda] API base URL:', BASE_URL);

const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
